module.exports = __webpack_public_path__ + "fonts/DiptyqueSaintGermain-Regular.5558384.woff2";